import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { EmptyState, StateMatrix } from "@/shared/ui";
import { myCatalogsQuery } from "./queries";

export function CatalogsPage() {
  const q = useQuery(myCatalogsQuery);
  return (
    <div className="mx-auto max-w-4xl p-8">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold">Catalogs</h1>
        <p className="mt-1 text-sm text-[var(--fg-muted)]">
          Documentation sources you can read.
        </p>
      </header>
      <StateMatrix
        status={q.status}
        data={q.data}
        error={q.error}
        onRetry={() => q.refetch()}
        isFetching={q.isFetching}
        isEmpty={(d) => d.length === 0}
        empty={
          <EmptyState
            title="No catalogs yet"
            description="An admin needs to grant you access to at least one catalog."
          />
        }
      >
        {(catalogs) => (
          <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {catalogs.map((c) => (
              <li key={c.id}>
                <Link
                  to="/catalogs/$name"
                  params={{ name: c.name }}
                  className="block rounded-lg border border-[var(--border)] bg-[var(--surface)] p-4 transition-colors hover:bg-[var(--surface-2)]"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="font-medium">{c.label}</p>
                      <p className="mt-0.5 text-xs text-[var(--fg-muted)]">{c.name}</p>
                    </div>
                    <span className="rounded-full bg-[var(--surface-2)] px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-[var(--fg-muted)]">
                      {c.perm}
                    </span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </StateMatrix>
    </div>
  );
}
